import React from 'react';

import SalonSpinner from 'components/generic/SalonSpinner.component';

const OverlaySpinner = (props) => (
  // TODO: use portals
  // SEE: https://react.dev/reference/react-dom/createPortal
  // SEE: https://legacy.reactjs.org/docs/portals.html

  <SalonSpinner {...props} variant="overlay" />
);

export default OverlaySpinner;
